import React, { MouseEvent, useState, Dispatch, useEffect } from 'react';
import { gameVote, fetchGames } from '../../features/player/gameSlice'
import { fetchGameStatus } from '../../features/player/gameStatusSlice'
import { IGameStatus, ICOA } from '../../interfaces';
import { InjectVote } from '../../Classes1';
import VotePercentage from './VotePercentage';
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import _ from 'lodash';

import Modal from 'react-modal';

interface COAVoteItemProps {
    currentGameStatus: IGameStatus; 
    currentId: number;
    coa: ICOA;
    injectImages: any[];
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void
    iVoted: boolean;
    setIVoted: Dispatch<any>;
    currentInjectId: number;
}

const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '640px',
      transform: 'translate(-50%, -50%)',
    }
  };

  Modal.setAppElement('#root');

  const COAVoteItem: React.FC<COAVoteItemProps> = ({ currentGameStatus, currentId, coa,  injectImages, intervalHandler, iVoted, setIVoted, currentInjectId }) => {

    const dispatch = useAppDispatch();

    const user = useAppSelector((state) => state.auth.userId)

    const [votingModalIsOpen, setVotingModalIsOpen] = useState<boolean>(false);
    const [rejectedVoteIsOpen, setRejectedVoteIsOpen] = useState<boolean>(false);
    const [voteReason, setVoteReason] = useState<string>('');
    const [voteCount, setVoteCount] = useState<number>(0);
    const [votePercentage, setVotePercentage] = useState<number>(0);
    const [voteReasonError, setVoteReasonError] = useState<boolean>(false);
    const [iVotedCOA, setIVotedCOA] = useState<boolean>(false);
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);

    useEffect(() => {

        let votesCount: number = 0;

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'action' && currentGameStatus.moves[i].options.choiceType === 'coa' && currentGameStatus.moves[i].choice === currentId.toString() && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'action') {
                    setIVotedCOA(true)
                }
                votesCount++;
            }
        }

        setVoteCount(votesCount)
        setVotePercentage((votesCount/currentGameStatus.players.length))

    }, [currentGameStatus.moves]) // eslint-disable-line react-hooks/exhaustive-deps

    const openVotingModal = () => {
        setVotingModalIsOpen(true);
    }

    const closeVotingModal = () => {
        setVotingModalIsOpen(false);
    }

    const clickBigVote = (ev: MouseEvent) => {
        if (!iVotedCOA) {
            openVotingModal()
        }
    }

    const openRejectedVote = () => {
        setRejectedVoteIsOpen(true);
    }

    const closeRejectedVote = () => {
        setRejectedVoteIsOpen(false);
    }

    const submitVote = async (ev: MouseEvent) => {

        if (disableSubmit) {
            return;
        }

        const target = ev.currentTarget as HTMLTextAreaElement;

        if (target) {

            if (_.isEmpty(voteReason)) {
                // show reason error
                setVoteReasonError(true)
                
            } else {
                setDisableSubmit(true)
                let gameVoteObj: any = {};
                gameVoteObj.gameId = currentGameStatus.gameId;
                gameVoteObj.voteObj = {};
                let newVote;

                newVote = new InjectVote();
                newVote.type = 'action';
                newVote.choice = currentId.toString();
                newVote.reason = voteReason;
                newVote.actionOptions = {
                    injectId: currentInjectId!.toString(),
                    choiceType: 'coa'
                }
                
                gameVoteObj.voteObj = newVote;

                const gameVoteResponse: any = await dispatch(gameVote(gameVoteObj));
                if (gameVoteResponse.error !== undefined) {
                    openRejectedVote();
                }

                closeVotingModal();
                setVoteReason('');
                setDisableSubmit(false);

                await dispatch(fetchGameStatus(currentGameStatus.gameId));
                await dispatch(fetchGames());
                intervalHandler("start", currentGameStatus.gameId, true);
            }
        }
    }

    const onChangeReason = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
        const target = ev.currentTarget as HTMLTextAreaElement;

        if (target) {
            setVoteReason(target.value)
        }
    }

    const clickReasonTextarea = (ev: MouseEvent) => {
        ev.stopPropagation();
    }

    return (
        <div>
            <div className={`game-vote-item ${iVotedCOA ? 'already-voted' : ''}`} onClick={clickBigVote}>
                {/*<div className="game-vote-item-title">
                        {coa.displayText}
                    </div>*/}
                    <div className="game-vote-item-details">
                        <div className="game-vote-item-text">
                            {coa.displayText}
                        </div>
                        <div className="game-vote-item-votes">
                            <VotePercentage iVoted={false} iVotedCOA={iVotedCOA} voteCount={voteCount} votePercentage={votePercentage} />
                        </div>
                    </div>
                </div>

            <Modal
                isOpen={votingModalIsOpen}
                onRequestClose={closeVotingModal}
                style={customStyles}
                shouldCloseOnOverlayClick={true}
                contentLabel="Voting Modal"
            >
                <div className="vote-modal-header">Vote Reasoning <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeVotingModal}></img></div>

                <div className="vote-modal-text">Please describe your reasoning for selecting this COA.</div>

                { voteReasonError ? <div className="vote-reason-error">Vote reason required</div> : <></> }
                <textarea className="vote-reason-text" value={voteReason} onChange={onChangeReason} onClick={clickReasonTextarea}></textarea>

                <button onClick={closeVotingModal} className="new-cancel-btn"><span>Cancel</span></button>
                <button onClick={submitVote} className="new-confirm-btn"><span>Submit</span></button>
            </Modal>

            <Modal
                isOpen={rejectedVoteIsOpen}
                onRequestClose={closeRejectedVote}
                style={customStyles}
                contentLabel="Rejected Vote Modal"
            >
                <div className="game-over-message">You already voted for this inject.</div>
                <button onClick={closeRejectedVote} className="join-game delete-cancel-btn">Close</button>
            </Modal>

        </div>
    )

  }

  export default COAVoteItem